<glxy-form-field
  [horizontalLayout]="horizontalLayout"
  [prefixText]="symbol"
  [size]="size ? (size | translate) : 'default'"
  [ngClass]="{
    'no-hint-message': !hint && (!formControl.invalid || formControl.pristine),
  }"
  [bottomSpacing]="bottomSpacing ? bottomSpacing : 'default'"
  [suffixText]="suffixText"
  [maxWidth]="maxWidth"
  [minWidth]="minWidth"
  [disabled]="viewOnly"
>
  @if (!!label) {
    <glxy-label>{{ label | translate }}</glxy-label>
  }
  @if (disableAutoComplete) {
    <input style="display: none" type="text" name="disable-autocomplete" />
  }
  <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
  <input
    class="glxy-currency-field"
    #currencyField
    matInput
    [id]="id"
    [name]="id"
    [formControl]="internalFormControl"
    placeholder="{{ placeholder ? (placeholder | translate) : '' }}"
    [required]="!!required"
    type="text"
    (blur)="handleBlur(currencyField.value)"
    (input)="handleInput()"
    [autocomplete]="disableAutoComplete ? 'chrome-off' : 'on'"
    [readonly]="viewOnly"
  />
  <ng-content glxySuffix select="[glxySuffix]" />
  @if (hint) {
    <glxy-hint>{{ hint | translate }}</glxy-hint>
  } @else {
    <ng-content select="glxy-hint" />
  }
  <!-- allow adding a custom hint if you don't specify a normal one -->

  @if (validatorError$ | async; as validatorError) {
    <glxy-error>
      @if (validatorError !== '') {
        {{ validatorError | translate }}
      }
    </glxy-error>
  }
  <ng-content select="[glxyError]" />
</glxy-form-field>
